import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
  margin: 0.75rem;
`;
